<template>
    <validation-observer slim #default="{ invalid }">
        <form class="promo-form" ref="promoForm" @submit.prevent="onSubmit(invalid)">
            <div class="promo-form__row">
                <validation-provider rules="required|email" #default="{ errors }">
                    <text-input
                        class="promo-form__email"
                        id="promo_form_email"
                        name="email"
                        label="E-mail"
                        v-model="email"
                        :class="{
                            'has-error': isEmailInvalid || errors.length,
                            'has-success': !errors.length,
                        }"
                        :readonly="isLoading"
                        @input="onEmailInput"
                        v-focus
                    ></text-input>
                </validation-provider>
            </div>

            <div class="promo-form__row">
                <button
                    class="btn btn-block btn-main"
                    type="submit"
                    :disabled="!email || invalid || isSubscribed"
                >
                    <span v-if="isLoading" class="spinner-border spinner-border-sm"/>
                    <template v-else>{{ btnText }}</template>
                </button>
            </div>
        </form>
    </validation-observer>
</template>

<script>

export default {
    name: 'promo-form',

    data() {
        return {
            email: '',
            emailStatus: '',
            btnText: 'Получить скидку',
            isEmailInvalid: false,
            isSubscribed: false,

            isAuthorized: false,
            isLoading: false,
        };
    },

    methods: {

        /**
         * Обработка ввода email
         */
        onEmailInput() {
            this.isEmailInvalid = false;
        },

        /**
         * Отправить форму
         */
        sendSubscribeForm() {
            if (this.isLoading) return;

            if (this.email) {
                this.isLoading = true;
                fetch('/api/user/subscribe/', {
                    method: 'POST',
                    body: new FormData(this.$refs.promoForm),
                })
                    .then((response) => response.json())
                    .then((result) => {
                        const isSuccess = result.status === 'success';
                        this.isLoading = false;
                        this.isSubscribed = true;
                        this.btnText = isSuccess ? 'Перейдите в почту для активации скидки' : result.message;
                        this.isEmailInvalid = !isSuccess;
                    });
            }
        },

        onSubmit(invalid) {
            if (invalid) return;

            if (this.email || !invalid) {
                this.sendSubscribeForm();
            }
        },
    },
};
</script>
